export const ADD_MEDA_DETAILS = "ADD_MEDA_DETAILS";
export const MEDA_DETAILS_LOADING = "MEDA_DETAILS_LOADING";
export const MEDA_DETAILS_FAILED = "MEDA_DETAILS_FAILED";
